import Service, { getCallApiFunction } from '../service'

type ParamsType = {
  roomId: string
}

/**
 * 競標房的拍品清單。
 *
 * 依「shop-api 競標前後端交互規格」的資料來源分工：這支只給「拍品長什麼樣」
 * （名稱、圖、起標價、加價幅度、剩餘件數），**刻意不含即時競標狀態**
 * （當前價、剩餘秒數、誰最高價都走 tAuction 的 WebSocket sid=27）。
 * 清單無分頁；更新用 fetchAuctionLotsVersion 輪詢版本號比對，不要輪整份清單。
 *
 * 刻意不帶 only_available：開拍會預扣庫存讓 quantity_remaining −1，只有 1 件的拍品在開拍當下
 * 就會從 only_available=true 的結果消失，競標中與結標後的卡片就查不到商品名稱與圖。
 * 整份拿回來，能不能開拍由 status / quantityRemaining 各自判斷（kit 的 fetchRoomProductData 同理）。
 */
class FetchAuctionLotsApi extends Service {
  constructor({ roomId }: ParamsType) {
    super()
    this.name = 'FETCH_AUCTION_LOTS'

    this.config = {
      url: `/v2/room/${roomId}/auction/lots`,
      method: 'GET',
    }
  }
}

export const fetchAuctionLots = (params: ParamsType) => getCallApiFunction(new FetchAuctionLotsApi(params))
